import http from '@plugins/axios';

export const state = {
  masters: null,
};

export const mutations = {
  SET_MASTERS(state, newValue) {
    state.masters = Object.assign({}, state.masters, newValue);
  },
};

export const actions = {
  async getMasters({ state, commit }, payload) {
    // check masters on state
    const masters = (state.masters && Object.keys(state.masters)) || [];
    const mastersRequest = (payload || '').split(';') || [];
    const mastersForRequest = mastersRequest.filter((item) => masters.indexOf(item) === -1);

    if (mastersForRequest && mastersForRequest.length) {
      const { data } = await http
        .get(`psp/gtk/preferensi/masters?data=${mastersForRequest.join(';')}`)
        .then(({ data }) => data);
      commit('SET_MASTERS', data);
    }

    return state.masters;
  },
};
